import React, { Fragment, useMemo } from 'react';
import AppTable from '../../../../constants/AppTable';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store/store';
import { useDispatch } from 'react-redux';
import { ISSUE_DELETE_PRODUCT_ITEM } from '../../../../store/inventorySlice';
import { IssueProductListReducer } from '../../../../helpers/models/Models';

const ProductIssueListView = () => {
  const dispatch = useDispatch();
  const { IssueProductList } = useSelector((state: RootState) => state.inventory);
  const columns = useMemo(() => [
    { header: 'SN', accessor: 'sn', sortable: false },
    { header: 'Store Name', accessor: 'store', sortable: true },
    { header: 'Product', accessor: 'product', sortable: false },
    { header: 'Issue Date', accessor: 'pur_sale_date', sortable: false },
    { header: 'Return Date', accessor: 'due_date', sortable: false },
    { header: 'Member SN', accessor: 'member_sn', sortable: false },
    { header: 'Issue Quantity', accessor: 'issue_qty', sortable: false },
    { header: 'Total Amount', accessor: 'tot_amt', sortable: false },
    { header: 'Actions', accessor: 'actions', action: true },
  ], []);
  
  const modifiedData: IssueProductListReducer[] = useMemo(() => {
    if (!IssueProductList) return [];
    return IssueProductList.map((item, index) => ({
      ...item,
      sn: index + 1,
    }));
  }, [IssueProductList]);

  const handleDelete = (items: IssueProductListReducer) => {
    dispatch(ISSUE_DELETE_PRODUCT_ITEM(items.product));
  };

  return (
    <Fragment>
      <AppTable
        columns={columns}
        data={modifiedData}
        onDelete={handleDelete}
      />
    </Fragment>
  );
}

export default ProductIssueListView